import React from "react";
import { useEffect, useState } from "react";

import { DataComp } from "../../Component/DataComp";

import { webPath } from "../../apiconfig";
import LazyLoad from "react-lazyload";



export function ArticleComp({ data }) {
  const [className, setClassName] = useState("")

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {

      const removeTimer = setTimeout(() => {
        setClassName('');
      }, 0);


      const setTimer = setTimeout(() => {
        setClassName('loaded');
        currentSection++;


        if (currentSection <= sections) {
          setSectionClassName();
        }
      }, currentSection * 40);


      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    setSectionClassName();
  }, []);
  return (
    <div>

      <div className="container mt-3">
        <div className="row">
          <h5 className="fw-bold borderB py-1 h4">News</h5>


          <div className="mainSecondBox">
            <div className="row">

              {data && data.length > 0 ? (
                data?.slice(0, 3).map((item) => (
               
                  <div key={item.id} className="col-md-4 col-12">
                    <a className="a-link text-black" href={`/${item.cat_slug}/${item.post_name}`}>
                      <DataComp
                        src={`${webPath}${item.banner_img}?width=500`}
                        alt={item.post_name}
                        h2Title={item.post_title}
                        p_Desc={item?.p_content}
                        post_author={item.post_author}
                        post_date={item.post_date}
                        withZoom={true}
                      />
                    </a>
                  </div>
              
                ))
              ) : (
                <div className="mt-3">
                  <LazyLoad className={className}>
                  <h5>No  Posts Available</h5>
                  </LazyLoad>
                </div>
              )}
            </div>

          </div>

        </div>
      </div>


    </div>
  );
}
